import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import useApi from 'hooks/useApi';

// ==============================|| ANALYTICS ||============================== //

const DashboardAnalytics = () => {
  const { getAnalyticsEmbedUrl, showToast } = useApi();
  const [iframeUrl, setIframeUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchEmbedUrl = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await getAnalyticsEmbedUrl();
      if (response?.success && response?.data?.iframeUrl) {
        setIframeUrl(response.data.iframeUrl);
      } else {
        setError(true);
        showToast('Failed to load analytics', 'error');
      }
    } catch (err) {
      setError(true);
      showToast('Failed to load analytics', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmbedUrl();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 60px)' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !iframeUrl) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 60px)', gap: 2 }}>
        <Typography variant="h6" color="text.secondary">
          Unable to load analytics
        </Typography>
        <Button variant="contained" onClick={fetchEmbedUrl}>
          Retry
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', height: 'calc(100vh - 80px)' }}>
      <iframe
        src={iframeUrl}
        frameBorder="0"
        width="100%"
        height="100%"
        allowTransparency
        style={{ border: 'none', display: 'block' }}
        title="Analytics"
      />
    </Box>
  );
};

export default DashboardAnalytics;
